export const giveawayPickerUrl = `${process.env.NEXT_PUBLIC_BASE_API_URL}/api/lead/login/facebook?type=sign_in`;
export const giveawayPickerWebflowUrl = 'https://instagram-giveaway-picker.iconosquare.com/';
